const searchFormValue = {
    search: null,
    locale: null,
};

const localeOptions = [
    { text: '전체', value: null },
    { text: '한국어', value: 'ko' },
    { text: '영어', value: 'en' },
    { text: '중국어', value: 'ca' },
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'key',
        label: '문자열 키',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'ko',
        label: '한국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'en',
        label: '영어',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'ca',
        label: '중국어',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

export { searchFormValue, columns, localeOptions};
